import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Logo from "../../images/Viridi.png";
import { useTranslation } from "react-i18next";
import TranslateComponent from "../../components/TranslateComponent";

const Header = (props) => {
  const { t, i18n } = useTranslation();
  const { title, link, breadcm, description } = props;
  const [show, setShow] = useState(true);
  const [language, setLanguage] = useState(
    localStorage.getItem("lang") === "is" ? false : true
  );
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // setLanguage(localStorage.getItem("lang") === "en" ? true : false);
    changeLanguage(localStorage.getItem("lang"));
  }, [language]);

  const changeLanguage = (lng) => {
    localStorage.setItem("lang", lng);
    i18n.changeLanguage(lng); // Function to change the language
  };

  const onLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  const handleChangePassword = () => {
    navigate("/changepassword");
  };

  return (
    <div className="headerBg">
      <div className="titleBg">
        <span
          className="barIcon"
          style={{ opacity: "0" }}
          onClick={() => {
            setShow(!show);
          }}
        >
          <i className="fa-solid fa-bars"></i>
        </span>

        {/* {show && <p ref={ref}>Hello world</p>} */}

        <div>
          <h5>
            {localStorage.getItem("gs3_AuthToken") ? (
              <>
                <Link className="backpage">
                  <i
                    className="fa-solid fa-angle-left"
                    onClick={() => navigate(-1)}
                  ></i>
                </Link>
                <span className="brdcm">{breadcm}</span>
                {title}
              </>
            ) : (
              <Link to={"/"} className="vir">
                <img src={Logo} alt="" />
              </Link>
            )}
          </h5>
          <p>{description}</p>
        </div>
      </div>
      {localStorage.getItem("gs3_AuthToken") && (
        <div className="headerRight">
          {/* {props.title === "Solution" || props.title === "Service" ? (
            ""
          ) : (
            <button className="commonButton">
              <i className="fa-solid fa-plus"></i>{" "}
              {t("add") + " " + t("IES Provider")}
            </button>
          )} */}

          {/* <div className="toggle-container">
            <TranslateComponent />
          </div> */}

          {/* <div className="toggle-container">
            <label className="switch">
              <input
                type="checkbox"
                checked={language}
                onChange={(e) => (
                  setLanguage(e.target.checked),
                  changeLanguage(e.target.checked ? "en" : "is")
                )}
              />
              {language ? (
                <span className="slider round"></span>
              ) : (
                <span className="slideroff round"></span>
              )}
            </label>
            <p style={{ marginBottom: "3px" }}>
              {language ? "English" : "Icelandic"}
            </p>
          </div> */}

          <div className="notifyBar">
            <i className="fas fa-bell"></i>
            <div className="dropdown">
              <button
                className="dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                1
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <div className="announceNotify">
                  <div className="announceBlock">
                    <i className="fas fa-bell"></i>
                    <div className="anb">
                      <p>Dolar ipsum dolor sit amet, sect etur adipiscing </p>
                      <span>13th Jan, 2022</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="userDrop">
            <button
              className="dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa-solid fa-user fs-4"></i>
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button onClick={handleChangePassword}>
                {t("Change Password")}
              </button>
              <button onClick={onLogout}>
                {t("Log out")} &nbsp;
                <i className="fa-solid fa-right-from-bracket"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
